import { ANKETA_MAIN_HOST } from '@alfa-bank/site-envconfig';

export const RECIPIENT_HOST = `${ANKETA_MAIN_HOST()}`;

export const RECIPIENT_URL = `${RECIPIENT_HOST}/alfaform-common-land/?`;
